module.exports = __webpack_public_path__ + "img/Instagram.986ef9a8.svg";